import { ReduxKit } from '@team/redux';

const named = ReduxKit.eventNameBuilder('system');

/**
 * Событие "DOM полностью загружен и разобран"
 */
export const domContentLoaded = ReduxKit.createEvent(
  named('init/dom-content-loaded')
);

/**
 * Событие "Система произвела первый рендер"
 */
export const rendered = ReduxKit.createEvent(named('init/rendered'));

/**
 * Событие "Система завершила инициализацию"
 */
export const completed = ReduxKit.createEvent<{ result: boolean }>(
  named('init/completed')
);
